/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MdmActiveInvestigationLockSummaryDto } from './MdmActiveInvestigationLockSummaryDto';
import {
    MdmActiveInvestigationLockSummaryDtoFromJSON,
    MdmActiveInvestigationLockSummaryDtoFromJSONTyped,
    MdmActiveInvestigationLockSummaryDtoToJSON,
    MdmActiveInvestigationLockSummaryDtoToJSONTyped,
} from './MdmActiveInvestigationLockSummaryDto';

/**
 * Resolve USER golden record to Person/Account projection for investigation lock UI (MDM-MATCH.18h)
 * @export
 * @interface UserGoldenProjectionResolveResponse
 */
export interface UserGoldenProjectionResolveResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserGoldenProjectionResolveResponse
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserGoldenProjectionResolveResponse
     */
    resolved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    projectionKind?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    projectionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserGoldenProjectionResolveResponse
     */
    ambiguousProjection?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    personGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    accountGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    employeeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    upn?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    accountSubtype?: string;
    /**
     * 
     * @type {Array<MdmActiveInvestigationLockSummaryDto>}
     * @memberof UserGoldenProjectionResolveResponse
     */
    activeLocks?: Array<MdmActiveInvestigationLockSummaryDto>;
    /**
     * 
     * @type {string}
     * @memberof UserGoldenProjectionResolveResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the UserGoldenProjectionResolveResponse interface.
 */
export function instanceOfUserGoldenProjectionResolveResponse(value: object): value is UserGoldenProjectionResolveResponse {
    return true;
}

export function UserGoldenProjectionResolveResponseFromJSON(json: any): UserGoldenProjectionResolveResponse {
    return UserGoldenProjectionResolveResponseFromJSONTyped(json, false);
}

export function UserGoldenProjectionResolveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGoldenProjectionResolveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'resolved': json['resolved'] == null ? undefined : json['resolved'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'projectionKind': json['projectionKind'] == null ? undefined : json['projectionKind'],
        'projectionId': json['projectionId'] == null ? undefined : json['projectionId'],
        'ambiguousProjection': json['ambiguousProjection'] == null ? undefined : json['ambiguousProjection'],
        'personGoldenId': json['personGoldenId'] == null ? undefined : json['personGoldenId'],
        'accountGoldenId': json['accountGoldenId'] == null ? undefined : json['accountGoldenId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'upn': json['upn'] == null ? undefined : json['upn'],
        'email': json['email'] == null ? undefined : json['email'],
        'accountSubtype': json['accountSubtype'] == null ? undefined : json['accountSubtype'],
        'activeLocks': json['activeLocks'] == null ? undefined : ((json['activeLocks'] as Array<any>).map(MdmActiveInvestigationLockSummaryDtoFromJSON)),
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function UserGoldenProjectionResolveResponseToJSON(json: any): UserGoldenProjectionResolveResponse {
    return UserGoldenProjectionResolveResponseToJSONTyped(json, false);
}

export function UserGoldenProjectionResolveResponseToJSONTyped(value?: UserGoldenProjectionResolveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'resolved': value['resolved'],
        'goldenRecordId': value['goldenRecordId'],
        'projectionKind': value['projectionKind'],
        'projectionId': value['projectionId'],
        'ambiguousProjection': value['ambiguousProjection'],
        'personGoldenId': value['personGoldenId'],
        'accountGoldenId': value['accountGoldenId'],
        'reason': value['reason'],
        'displayName': value['displayName'],
        'employeeId': value['employeeId'],
        'upn': value['upn'],
        'email': value['email'],
        'accountSubtype': value['accountSubtype'],
        'activeLocks': value['activeLocks'] == null ? undefined : ((value['activeLocks'] as Array<any>).map(MdmActiveInvestigationLockSummaryDtoToJSON)),
        'errorMessage': value['errorMessage'],
    };
}

